module.exports = "textarea\r\n{\r\n   resize: none;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/dashboard/for-signing/decline/decline.dialog.component.css
// module id = ./src/app/components/dashboard/for-signing/decline/decline.dialog.component.css
// module chunks = main